













































export default {
	name: 'ThemePreviewer',
	props: {
		logo: {
			type: String,
			required: true,
		},
	},
	data: () => ({
		gmail: require('@/assets/gmail.jpg'),
	}),
};
